export const environment = {
  production: true,
  graphql_endpoint: 'https://beheer.bovo-werkomgeving.nl/api/graphql',
};
